import React, { useState } from 'react'
import "./Style/Style.css";
import doctor from "./Assits/doctor.png"
import { Link,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Spinner from 'react-bootstrap/Spinner';
import { loginfunction } from './services/Apis';
import "../App.css"

const Login = ({setProgress}) => {
  let navigate = useNavigate();
  // const[spiner,setSpiner] = useState(false);
  const [inpval, setInpval] = useState({
    email: "",
    password: "",
  });
  const setVal = (e) => {
    // console.log(e.target.value);
    const { name, value } = e.target;

    setInpval(() => {
        return {
            ...inpval,
            [name]: value
        }
    })
  };
  const loginuser = async(e) =>{
    e.preventDefault();

    const{email,password} = inpval;
    if (email==="") {
      toast.error("email is required!", {
        position: "top-center"
    });
    }else if (!email.includes("@")) {
      toast.warning("includes @ in your email!", {
        position: "top-center"
    });
    }else if (password==="") {
      toast.error("password is required!", {
        position: "top-center"
    });
    }else if (password.length<6) {
      toast.error("password is required!", {
        position: "top-center"
    });
    }
    else{

      // setSpiner(true)
      setProgress(20)
      setProgress(40)
      setProgress(60)
      const res = await loginfunction(inpval);
      // console.log(res);
      
      if (res.status ===201) {
        setProgress(80)
        // console.log(res.data.token);
        localStorage.setItem("userdatatoken", res.data.token)
        setProgress(100)
        // setSpiner(false)
        navigate("/")
        setInpval({...inpval,email:"",password:""});
      }
      else{
        setProgress(80)
        setProgress(100)
        toast.error("please login with correct credentials!", {
          position: "top-center"
      });
        setInpval({...inpval,email:"",password:""});
      }
    }
  }

  return (
    <div>
        <section className="log">
        <div className="login-box">
            <div className="login-img">
                <img src={doctor} alt=""/>
            </div>
            <div className="login-contain">
                    <h1>Log In</h1>
                    <div className="input-box">
                        <i className=" fas fa-solid fa-user"></i><input type="text" onChange={setVal} value={inpval.email} name="email" placeholder="Your Email"/>
                    </div>
                    <div className="input-box">
                        <i className="fas fa-solid fa-lock"></i><input type="password" onChange={setVal} value={inpval.password} name="password" placeholder="Password"/>
                    </div>
                    <div className="login-btn">
                        <button className="bt" onClick={loginuser}>Login</button>
                        <Link className="bt" to="/register" style={{textDecoration:"none"}}>Create an account</Link>
                        {/* <button className="bt" >Create an account</button> */}

                    </div>
            </div>
            <ToastContainer />
        </div>
      </section>    
    </div>
  )
}

export default Login
